import { render, staticRenderFns } from "./info-lecturers.vue?vue&type=template&id=791d373c&"
import script from "./info-lecturers.vue?vue&type=script&lang=js&"
export * from "./info-lecturers.vue?vue&type=script&lang=js&"
import style0 from "./info-lecturers.vue?vue&type=style&index=0&id=791d373c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports